<template>
  <div class="checkin-area">
    <div
      class="buttonArea"
      :class="{
        disabled: isCheckedIn || distance > checkinDistance,
      }"
      @click="onClickCheckin"
    >
      <div class="buttonMainArea">
        <img class="buttonAreaImg" src="@/assets/pin.svg" />
        <div>
          {{ isCheckedIn ? "チェックイン済み" : "チェックイン" }}
        </div>
      </div>
    </div>
    <!-- <div
      class="so-far-text"
      v-if="isLoggedInWithFirebaseAuth === false && !isCheckedIn"
      @click="onClickSignin"
    >
      <p>ログインしてください</p>
    </div> -->
    <div class="so-far-text" v-if="distance > checkinDistance && !isCheckedIn">
      <p>{{ checkinDistance }}m以内に近づいてください。</p>
    </div>
    <GetCheckinPointDailog
      v-if="isShowPointDialog"
      :checkinPoint="selectedSpot.CheckIn"
      @click-close="onClickCloseGetPoint"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import GetCheckinPointDailog from "./GetCheckinPointDailog";
import { CHECKIN_INTERVAL, CHECKIN_DISTANCE } from "../../const.js";
import Firebase from "./../../firebase";

export default {
  name: "checkin-area",
  components: { GetCheckinPointDailog },
  props: {
    selectedSpot: {
      type: Object,
      require: true,
    },
    distance: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      isShowPointDialog: false,
    };
  },
  computed: {
    ...mapState(["checkinList", "isLoggedInWithFirebaseAuth"]),
    checkinDistance() {
      return CHECKIN_DISTANCE;
    },
    isCheckedIn() {
      return (
        this.checkinList
          .filter((x) => this.selectedSpot.id === x.spotId)
          .filter((mission) => {
            const formattedTargetDate = this.formatDateToCalc(
              new Date(mission.CreatedAt),
            );
            return (
              this.formattedCurrentDate - formattedTargetDate < CHECKIN_INTERVAL
            );
          }).length !== 0
      );
    },
    formattedCurrentDate() {
      const formattedCurrentDate = this.formatDateToCalc(new Date());
      return formattedCurrentDate;
    },
  },
  methods: {
    ...mapMutations(["loadingStartMini", "loadingEndMini", "setModal"]),
    onClickCloseGetPoint() {
      this.isShowPointDialog = false;
    },
    onClickSignin() {
      this.setModal("signin");
    },
    formatDateToCalc(dt) {
      var y = String(dt.getFullYear());
      var m = String(("00" + (dt.getMonth() + 1)).slice(-2));
      var d = String(("00" + dt.getDate()).slice(-2));

      return Number(`${y}${m}${d}`);
    },
    async onClickCheckin() {
      if (this.isLoggedInWithFirebaseAuth === false) {
        this.setModal("signin");
        return;
      }

      // TODO
      if (this.isCheckedIn || this.distance > this.checkinDistance) return;

      this.loadingStartMini();

      await Firebase.checkin({
        spotId: this.selectedSpot.id,
        spotDocId: this.selectedSpot.docId,
        name: this.selectedSpot.name,
        checkin: this.selectedSpot.CheckIn,
      });

      this.loadingEndMini();
      this.isShowPointDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.checkin-area {
  padding: 1rem 1.25rem;

  .buttonArea {
    width: 100%;
    margin: 0.5rem auto;
    border-radius: 4px;
    background: #ff7c86;
    &.disabled {
      background: #c3c3c3;
    }
    .buttonMainArea {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.75rem 0;
      color: white;
      font-weight: 700;
      .buttonAreaImg {
        height: 1rem;
        margin: auto 0;
        margin-right: 8px;
      }
    }
  }
  .so-far-text {
    text-align: center;
    color: #ff7c86;
    p {
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DropSpotSelectModal/CheckInArea.vue